import React, { Component } from "react";
import PropTypes from "prop-types";
import { CheckCircle } from "@styled-icons/material";

import styled from "styled-components/macro";
import { mediaQueries } from "../styles/media";

const pageWidths = {
  narrow: "var(--juno-page-width-narrow)",
  regular: "var(--juno-page-width-regular)",
  wide: "var(--juno-page-width-wide)",
  wider: "var(--juno-page-width-wider)",
};

const JunoConfirmation = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;

  color: var(--juno-color-header);
  background-color: var(--juno-color-pale-green);

  padding-top: 1em;
  padding-bottom: 1em;
  ${mediaQueries.md} {
    padding-top: ${(props) => (props.submission ? "1.5em" : "2em")};
    padding-bottom: ${(props) => (props.submission ? "1.5em" : "2em")};
  }

  margin-bottom: 1em;
  margin-top: ${(props) => (props.submission ? "-1em" : "0")};

  ${mediaQueries.md} {
    margin-top: -2em;
    margin-bottom: 1em;
  }

  h3 {
    margin: ${(props) => (props.submission ? "0" : "0 0 1em 0")};
  }

  p {
    ${mediaQueries.md} {
      font-size: ${(props) => (props.submission ? "var(--juno-font-size-body-sm)" : "var(--juno-font-size-body-md)")};
    }
  }
`;

const JunoConfirmationContent = styled.div`
  margin-left: var(--juno-space-6);
  margin-right: var(--juno-space-6);

  ${mediaQueries.md} {
    margin-left: var(--juno-space-12);
    margin-right: var(--juno-space-12);
  }

  ${mediaQueries.lg} {
    max-width: ${({ pageWidth }) => pageWidths[pageWidth]};
    margin-left: auto;
    margin-right: auto;
  }

  p,
  ul,
  ul li,
  a {
    font-size: var(--juno-font-size-body-sm);
  }

  ul:last-child {
    margin-bottom: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  a {
    color: var(--juno-color-black);
    font-weight: var(--juno-font-weight-bold);
    text-decoration: underline;
    border: none;
    &:hover {
      border: none;
    }
  }
`;

const JunoConfirmationHeading = styled.h3`
  display: flex;
  align-items: center;

  font-size: var(--juno-font-size-body-sm);
  ${mediaQueries.md} {
    font-size: var(--juno-font-size-body-md);
  }
`;

const JunoConfirmationIcon = styled(CheckCircle)`
  width: var(--juno-icon-size-xl);
  margin-right: 10px;
  ${mediaQueries.md} {
    margin-right: 16px;
  }
`;

class Confirmation extends Component {
  render() {
    return (
      <JunoConfirmation {...this.props}>
        <JunoConfirmationContent pageWidth={this.props.pageWidth}>
          <JunoConfirmationHeading>
            <JunoConfirmationIcon />
            <span>{this.props.title}</span>
          </JunoConfirmationHeading>
          {this.props.children}
        </JunoConfirmationContent>
      </JunoConfirmation>
    );
  }
}

export default Confirmation;

Confirmation.propTypes = {
  title: PropTypes.string.isRequired,
  pageWidth: PropTypes.oneOf(["narrow", "regular", "wide", "wider"]),
};

Confirmation.defaultProps = {
  pageWidth: "wide",
};
